import {TaskPageVO, useQueryTaskPage} from "@/service/task.s";
import React, {FC} from "react";
import {BtnType, ProTable} from "@/widget/ProTable/ProTable";
import {GridColDef} from "@mui/x-data-grid";
import {str2arr, stringAvatar} from "@/helper/method";
import Chip from "@mui/material/Chip";
import {assign} from "lodash";
import {Avatar, AvatarGroup} from "@mui/material";
import {useGlobalActions} from "@/store/global.c";
import {ViewTask} from "@/pages/Task/ViewTask";
import {WriteTask} from "@/pages/Task/WriteTask";
import {WriteAccepting} from "@/pages/Accepting/WriteAccepting";

export interface TaskTableProps {
    planId?: number;
}

export const TaskTable: FC<TaskTableProps> = ({planId}) => {
    const {
        mutate: taskPageMutate,
        data: taskPageData,
        isPending: taskPagePending,
    } = useQueryTaskPage()

    const {setDialogModal} = useGlobalActions()

    const columns: GridColDef<TaskPageVO>[] = [
        {field: "taskName", headerName: "任务名称", align: 'left', headerAlign: 'left', flex: 0.5,},
        {
            field: "priority",
            headerName: "优先级",
            headerAlign: "center",
            align: "center",
            renderCell: ({row: {priority, priorityId}}) => {
                let style = {}
                if (priorityId == 1) {
                    style = {backgroundColor: '#fa5353 !important', border: 'none'};
                } else if (priorityId == 2) {
                    style = {backgroundColor: '#ff9d8d !important', border: 'none'};
                } else if (priorityId == 3) {
                    style = {backgroundColor: '#f5c13c !important', border: 'none'};
                } else if (priorityId == 4) {
                    style = {backgroundColor: '#3f8cff !important', border: 'none'};
                } else if (priorityId == 5) {
                    style = {backgroundColor: '#2fcd6e !important', border: 'none'};
                }
                return <Chip label={priority} variant={'filled'} size={'small'} sx={assign(style, {"& .MuiChip-label": {color: '#fff'}})}/>
            }
        },
        {
            field: "status",
            headerName: "任务状态",
            headerAlign: "center",
            flex: 0.4,
            align: "center",
            renderCell: ({row: {status, statusId}}) => {
                let style = {}
                if (statusId == 1) {
                    style = {"& .MuiChip-label": {color: '#ff6692'}, backgroundColor: '#ffecf2 !important', border: 'none'};
                } else if (statusId == 2) {
                    style = {"& .MuiChip-label": {color: '#00ceb6'}, backgroundColor: '#e0f9f6 !important', border: 'none'};
                } else if (statusId == 3) {
                    style = {"& .MuiChip-label": {color: '#ffae1f'}, backgroundColor: '#fff5e4 !important', border: 'none'};
                }
                return <Chip label={status} variant={'filled'} size={'small'} sx={style}/>
            }
        },
        {
            field: "executors",
            headerName: "执行人",
            flex: 0.4,
            headerAlign: "center",
            align: "center",
            display: "flex",
            renderCell: (({row: {executors}}) => {
                const newExecutors: string[] = str2arr(executors, 'string')
                return <AvatarGroup sx={{
                    '& .MuiAvatarGroup-avatar': {
                        width: 32, height: 32, fontSize: 10, border: 'none'
                    }
                }} max={3}>
                    {newExecutors?.map((owner: string, index: number) => <Avatar key={index} {...stringAvatar(owner)} />)}
                </AvatarGroup>
            })
        },
    ]

    const btnCallback = async ({btn, keys}: BtnType<TaskPageVO>) => {
        if (btn.code == 'create_accepting') {
            setDialogModal({header: btn.remark, id: keys[0], open: true, body: <WriteAccepting mode={'dialog'} fromTask={true}/>})
        }
    }

    const viewCallback = ({keys, btn}: BtnType<TaskPageVO>) => {
        setDialogModal({body: <ViewTask mode={'dialog'}/>, maxWidth: 'sm', open: true, id: keys[0], header: btn.remark})
    }

    const editCallback = ({keys, btn}: BtnType<TaskPageVO>) => {
        setDialogModal({body: <WriteTask mode={'dialog'}/>, open: true, write: 'edit', id: keys[0], header: btn.remark})
    }

    return <ProTable<TaskPageVO> btnCallback={btnCallback} code={'task'} columnHeaderHeight={40} loading={taskPagePending}
                                 viewCallback={viewCallback}
                                 editCallback={editCallback}
                                 checkboxSelection={false}
                                 customFooter={true}
                                 renderDrawer={{write: <WriteTask/>}}
                                 onSearch={(params) => taskPageMutate({...params, planId})}
                                 data={taskPageData?.data} pageSize={5} showToolbar={false}
                                 columns={columns}/>
}